import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc constant
     * @name COLUMN_FILTER
     * @memberof app
     *
     * @description
     * These are keywords for names of columns that the column filter can be applied to.
     * In the backend the columns that will be filtered have to match the names of this constant.
     *
     * @author flzemke.btc
     */
    angular.module('app').constant('COLUMN_FILTER', {
        TABLE: {
            AUCTION_LIST: 'auctionList',
            AUCTION_REPORT: 'auctionReport',
            UPLOAD_REPORT: 'uploadReport',
            REVERSE_AUCTION_REPORT: 'reverseAuctionReport',
            SECONDARY_TRADE_REPORT: 'secondaryTradeReport',
            SECONDARY_TRADE_OVERVIEW: 'secondaryTradeOverview',
            SECONDARY_PROPOSAL_REPORT: 'secondaryProposalReport',
            SECONDARY_PROPOSAL_LIST: 'secondaryProposalList',
            SECONDARY_PROPOSAL_OVERVIEW: 'secondaryProposalOverview',
            EXTERNAL_ACER_TRADE_REPORT: 'externalAcerTradeReport',
            CONTRACT_POSITIONS_REPORT: 'contractPositionsReport',
            FCFS_BOOKING_REPORT: 'fcfsBookingReport',
            CAPACITY_LINKS_REPORT: 'capacityLinksReport',
            SURRENDERED_REPORT: 'surrenderReport',
            EXCHANGE_RATE_ARCHIVE: 'exchangeRateArchive',
            STORAGE_OFFERS: 'storageOffers',
            SHIPPER_ASSIGNMENTS: 'shipperAssignments',
            TRADE_AND_TRADE_PROPOSALS: 'tradeAndTradeProposals',
            NETWORK_POINT_OVERVIEW: 'networkPointOverview'
        },
        COL: {
            BID_RESULT: 'bidResult',
            NETWORK_POINT_NAME: 'networkPointName',
            NETWORK_POINT_ENTRY_NAME: 'entryNetworkPointName',
            NETWORK_POINT_EXIT_NAME: 'exitNetworkPointName',
            MARKETABLE: 'marketable',
            MARKETED: 'marketed',
            SURCHARGE: 'surcharge',
            START_OF_AUCTION: 'startOfAuction',
            AUCTION_ID: 'auctionId',
            CAPACITY_CATEGORY: 'capacityCategory',
            CATEGORY: 'category',
            CHANGED_AT: 'changedAt',
            DIRECTION: 'direction',
            STARTING_PRICE: 'startingPrice',
            TSO: 'tso',
            TSO_REF_ID: 'tsoRefId',
            BOOKED_CAPACITY: 'bookedCapacity',
            REGULATED_TARIFF: 'regulatedTariff',
            CONTRACT_ID: 'contractId',
            DEAL_ID: 'dealId',
            ENTRY_DEAL_ID: 'entryDealId',
            EXIT_DEAL_ID: 'exitDealId',
            CREATED_AT: 'createdAt',
            AMOUNT: 'amount',
            AMOUNT_QUATITY_VALUE: 'amountQuantityValue',
            QUANTITY: 'quantity',
            PROPOSAL: 'proposal',
            PROCEDURE: 'procedure',
            RUNTIME: 'runtime',
            PERIODTYPE: 'periodType',
            TRADING_CLOSE: 'tradingClose',
            TRADE_ID: 'tradeId',
            TRADE_LABEL: 'tradeLabel',
            PROPOSAL_ID: 'proposalId',
            GAS_TYPE: 'gasType',
            BOOKING_DATE: 'bookingDate',
            ISO_CODE: 'isoCode',
            VALIDITY_START: 'validityStart',
            VALIDITY_END: 'validityEnd',
            RATE: 'rate',
            ID: 'id',
            LINK_ID: 'LinkId',
            OFFER_LABEL: 'offerLabel',
            OFFER_ID: 'offerId',
            TSO_NAME: 'tsoName',
            TSO_SHORTNAME: 'tsoShortName',
            STORAGE_LOCATION: 'storageLocationName',
            OFFER_STATE: 'offerState',
            PRODUCT_TYPE: 'productType',
            ALLOCATION_STATE: 'allocationState',
            SHIPPER_NAME: 'shipperName',
            INITIATING_SHIPPER_NAME: 'initiatingShipperName',
            RESPONDING_SHIPPER_NAME: 'respondingShipperName',
            EIC: 'eic',
            ASSIGNMENT_STATE: 'state',
            PRIMARY_ACCESS: 'primaryAccess',
            SECONDARY_ACCESS: 'secondaryAccess',
            TYPE: 'type',
            NETWORK_POINT_OVERVIEW__TSO: 'TSO',
            PHASE_TYPES: 'phaseTypes',
            RAW_PRODUCT_STATE: 'rawProductState'
        },
        INITIAL: {
            PAST_DAYS: 1
        }
    });
})();
